import { withPaymentsClient } from './clients';
import { catchAndRethrowSensitiveNetworkError
// @ts-expect-error Untyped module
} from 'crm_data/bCommerce/monitoring/errorUtils';
import { DISCOUNT_CODE_NOT_VALID } from '../constants/ValidationErrors';
export const fetchBuyerOverridesSubtotals = withPaymentsClient((client, {
  buyerOverrides,
  paymentSessionId,
  taxCalculationId,
  paymentMethod
}) => {
  return client.post(`payments-checkout/v1/checkout-sessions/${paymentSessionId}/subtotals`, {
    data: {
      buyerOverrides,
      taxCalculationId,
      paymentMethod
    }
  }).catch(error => {
    // We don't want to send a Sentry error when a discount code is not valid
    if (JSON.parse(error.data).subCategory !== DISCOUNT_CODE_NOT_VALID) {
      catchAndRethrowSensitiveNetworkError(error);
    }
    throw error;
  });
});
export const fetchBuyerOverridesPreviewSubtotals = withPaymentsClient((client, {
  buyerOverrides,
  currencyCode,
  discount,
  adjustments,
  lineItems,
  portalId,
  paymentMethod,
  checkoutFees
}) => {
  return client.post('payments-checkout/v1/checkout-session-previews/subtotals', {
    query: {
      portalId
    },
    data: {
      buyerOverrides,
      currencyCode,
      discount,
      lineItems,
      adjustments,
      paymentMethod,
      checkoutFees
    }
  }).catch(error => {
    // We don't want to send a Sentry error when a discount code is not valid
    if (JSON.parse(error.data).subCategory !== DISCOUNT_CODE_NOT_VALID) {
      catchAndRethrowSensitiveNetworkError(error);
    }
    throw error;
  });
});